"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkipTo = void 0;
var _mui = require("@ori-ui/mui");
var _i18n = require("@ori/i18n");
var _defaultTranslations = require("../constants/defaultTranslations");
var _FormattedMessage = require("./FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const Link = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  padding: '5px 15px',
  position: 'absolute',
  top: 0,
  left: 0,
  backgroundColor: theme.palette.background.paper,
  zIndex: 99999,
  transform: 'translateX(-100%)' /* To hide the link from the screen */,
  transition: 'transform 0.3s' /* Make it focus smoothly */,
  '&:focus': {
    transform: 'translateX(0)' /* Show the link when focused */
  }
}));
/**
 * SkipTo Component
 *
 * A component that renders a list of accessible skip navigation links to improve
 * keyboard navigation for users. These links allow users to bypass repetitive
 * navigation sections and jump directly to specific parts of the page.
 * This component must be at the beggining of every layout
 *
 * @param links - Array of destination anchors to create skip links for.
 * Each string will be used to create an href with the format "#main-{link}".
 * Defaults to ['content', 'menu', 'search'].
 *
 * @returns JSX.Element - Collection of skip navigation links
 */
const SkipTo = ({
  links = ['content', 'menu', 'search']
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
  namespace: _defaultTranslations.translationsNamespace,
  children: links.map(link => /*#__PURE__*/(0, _jsxRuntime.jsx)(Link, {
    href: `#main-${link}`,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
      id: link
    })
  }, link))
});
exports.SkipTo = SkipTo;
